import { environment } from '../environments/environment';

export const env = {
  ...environment,
  defaultPoolname: environment.poolServiceName,
};
